export type Addable = {
  account: string;
  handle: string;
  displayName: string | null;
  avatar: string | null;
  kind: "person" | "agent";

  model: string | null;
};

export type WhoCouldCome = {
  people: readonly Addable[];

  agents: readonly Addable[];

  here: readonly string[];

  me: string;

  mayAdd: boolean;
};

export type Sections = { people: Addable[]; agents: Addable[] };

const lower = (said: string): string => said.toLowerCase();

export function carries(one: Addable, fragment: string): boolean {
  const want = lower(fragment.trim());
  if (want === "") return true;
  return lower(one.handle).includes(want) || lower(one.displayName ?? "").includes(want);
}

export function offered(who: WhoCouldCome, fragment = ""): Sections {
  if (!who.mayAdd) return { people: [], agents: [] };
  const inTheRoom = new Set([...who.here, who.me]);
  const keep = (list: readonly Addable[]): Addable[] =>
    list.filter((one) => !inTheRoom.has(one.account) && carries(one, fragment));
  return { people: keep(who.people), agents: keep(who.agents) };
}

export function howMany(sections: Sections): number {
  return sections.people.length + sections.agents.length;
}

export function toggled(chosen: ReadonlySet<string>, account: string): Set<string> {
  const next = new Set(chosen);
  if (!next.delete(account)) next.add(account);
  return next;
}

export function chosenOf(who: WhoCouldCome, chosen: ReadonlySet<string>): Addable[] {
  const all = offered(who);
  return [...all.people, ...all.agents].filter((one) => chosen.has(one.account));
}
